module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Checkmark_unselected_Gray.62ee7f9b.svg";